import type { QuestionnaireResponse } from "@medplum/fhirtypes";

export const QUESTIONNAIRE_RESPONSE_STATUS_COMPLETED: QuestionnaireResponse["status"] = "completed";
export const QUESTIONNAIRE_RESPONSE_STATUS_AMENDED: QuestionnaireResponse["status"] = "amended";

/** QuestionnaireResponse statuses included on amendment cards and routine amend history. */
export const AMENDMENT_HISTORY_QUESTIONNAIRE_RESPONSE_STATUSES = [
  QUESTIONNAIRE_RESPONSE_STATUS_COMPLETED,
  QUESTIONNAIRE_RESPONSE_STATUS_AMENDED,
] as const satisfies readonly QuestionnaireResponse["status"][];

const amendmentHistoryQuestionnaireResponseStatusSet = new Set<string>(
  AMENDMENT_HISTORY_QUESTIONNAIRE_RESPONSE_STATUSES,
);

/** Returns true when a QuestionnaireResponse version belongs in amendment history lists. */
export function isAmendmentHistoryQuestionnaireResponseStatus(
  status: QuestionnaireResponse["status"] | undefined,
): boolean {
  return status !== undefined && amendmentHistoryQuestionnaireResponseStatusSet.has(status);
}
